import { useEffect, useMemo, useState } from "react";
import { useFetch } from "@common/hook/useFetch";
import { IPortingSlots, IPortinSlot } from "@features/PortIn/interface/IPortinSlot";

export const useGetPortinSlot = (isSecured: boolean, portinSlotUrl: string) => {
    const [getPortinSlotState, { get }] = useFetch();
    const [portinSlotList, setPortinSlotList] = useState<IPortinSlot[]>([]);

    const getPortinSlot = useMemo(
        () => () => {
            get<{ portingHours: IPortingSlots[] }>(portinSlotUrl, { isSecured }).then((response) => {
                if (response) {
                    const timeRangeWithDate = response.portingHours.map((portingSlot) => ({
                        date: new Date(portingSlot.date),
                        startTime: new Date(portingSlot.startTime),
                        endTime: new Date(portingSlot.endTime),
                    }));

                    setPortinSlotList(timeRangeWithDate);
                }
            });
        },
        [get, isSecured, portinSlotUrl]
    );

    useEffect(getPortinSlot, [getPortinSlot]);

    return {
        getPortinSlotState,
        portinSlotList,
        getPortinSlot,
    };
};
